import { render, staticRenderFns } from "./DesignStatusForm.vue?vue&type=template&id=0f938b8b&"
import script from "./DesignStatusForm.vue?vue&type=script&lang=js&"
export * from "./DesignStatusForm.vue?vue&type=script&lang=js&"
import style0 from "./DesignStatusForm.vue?vue&type=style&index=0&id=0f938b8b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports